import request from '@/services/base/request'

const deploymentEnv = document.querySelector('meta[name="deployment-environment"]')
  ?.getAttribute('content') ?? 'production'

const ALLOWED_CALLBACK_ORIGINS: string[] = [
  'https://mobile.whitelist.capital'
].concat(
  process.env.NODE_ENV === 'development' || deploymentEnv === 'pre-release'
    ? ['http://127.0.0.1:5173', 'http://localhost:5173']
    : []
)

const ALLOWED_CALLBACK_SCHEMES: string[] = [
  'wlmobile:'
]

export function isAllowedCallbackUrl (url: string): boolean {
  try {
    const parsed = new URL(url)
    if (ALLOWED_CALLBACK_SCHEMES.includes(parsed.protocol)) {
      return true
    }

    return ALLOWED_CALLBACK_ORIGINS.some(function (origin) { return parsed.origin === origin })
  } catch {
    return false
  }
}

export default {
  requestAuthCode (): Promise<any> { return request('/mobile/auth-code/', 'post', null) }
}
